import { render } from "./KelayakanPengelolaan.vue?vue&type=template&id=3ccdc562"
import script from "./KelayakanPengelolaan.vue?vue&type=script&lang=js"
export * from "./KelayakanPengelolaan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__